import { z } from 'zod';

/**
 * Common Zod schemas shared across multiple API domains
 */

export const ImageOptimizationSchema = z.object({
  id: z.string(),
  imageUrlSource: z.string().nullable().optional(),
  imageUrlOptimized: z.string().nullable().optional(),
  imageSizeKbSource: z.number().nullable().optional(),
  imageSizeKbOptimized: z.number().nullable().optional(),
  imageOptimizedComplete: z.boolean().nullable().optional(),
  imageOptimizedLastUpdated: z.string().nullable().optional(),
  relID: z.number().nullable().optional(),
  field: z.string().nullable().optional(),
  relname: z.string().nullable().optional(),
});

export const CategorySchema = z.object({
  id: z.string(),
  label: z.string().nullable().optional(),
  parentCategory: z.string().nullable().optional(),
  slug: z.string().nullable().optional(),
  publishedAt: z.string().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});

export const EventCreatorSchema = z.object({
  id: z.string(),
  creatorName: z.string().nullable().optional(),
  creatorHandle: z.string().nullable().optional(),
  creatorUrl: z.string().nullable().optional(),
  creatorImage: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});

export const CollectionSchema = z.object({
  id: z.string(),
  ticker: z.string().nullable().optional(),
  slug: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  subtitle: z.string().nullable().optional(),
  collectionType: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  tags: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  headerImage: z.string().nullable().optional(),
  layout: z.string().nullable().optional(),
  active: z.boolean().nullable().optional(),
  closed: z.boolean().nullable().optional(),
  archived: z.boolean().nullable().optional(),
  new: z.boolean().nullable().optional(),
  featured: z.boolean().nullable().optional(),
  restricted: z.boolean().nullable().optional(),
  isTemplate: z.boolean().nullable().optional(),
  templateVariables: z.string().nullable().optional(),
  publishedAt: z.string().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
  commentsEnabled: z.boolean().nullable().optional(),
  imageOptimized: ImageOptimizationSchema.optional(),
  iconOptimized: ImageOptimizationSchema.optional(),
  headerImageOptimized: ImageOptimizationSchema.optional(),
});

export const TemplateSchema = z.object({
  id: z.string(),
  eventTitle: z.string().nullable().optional(),
  eventSlug: z.string().nullable().optional(),
  eventImage: z.string().nullable().optional(),
  marketTitle: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  resolutionSource: z.string().nullable().optional(),
  negRisk: z.boolean().nullable().optional(),
  sortBy: z.string().nullable().optional(),
  showMarketImages: z.boolean().nullable().optional(),
  seriesSlug: z.string().nullable().optional(),
  outcomes: z.string().nullable().optional(),
});

export const PaginationSchema = z.object({
  hasMore: z.boolean(),
  totalResults: z.number(),
});

export const CountSchema = z.object({
  count: z.number(),
});

export const EventTweetCountSchema = z.object({
  tweetCount: z.number(),
});

export const ChatSchema = z.object({
  id: z.string(),
  channelId: z.string().nullable().optional(),
  channelName: z.string().nullable().optional(),
  channelImage: z.string().nullable().optional(),
  live: z.boolean().nullable().optional(),
  startTime: z.string().nullable().optional(),
  endTime: z.string().nullable().optional(),
});
